/**
 * @generated SignedSource<<48102061e845d6ad88cd245a8a7ebc16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountManagementPageQuery$variables = {};
export type AccountManagementPageQuery$data = {
  readonly settings: {
    readonly artist: {
      readonly featuredDeals: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"ArtistManageDeals_featuredDeals">;
          } | null;
        } | null>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"ArtistEditSocialLinks_artist" | "ArtistManageDeals_artist" | "ArtistManageReleases_artist" | "ArtistManagerInfo_artist" | "ArtistViewTeam_teamMembers" | "BasicInfoFormArtist_artist">;
    } | null;
    readonly partner: {
      readonly company: {
        readonly " $fragmentSpreads": FragmentRefs<"CompanyInfo_company" | "CompanySocialLinks_company" | "CompanyTeam_company">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ArtistReferrals_partner" | "BasicInfoFormPartner_partner" | "PartnerReferrals_partner" | "PartnerViewRoster_artistRoster">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ArtistManageBank_user" | "EmailSubscriptions_user" | "ManageSubscription_user">;
  } | null;
};
export type AccountManagementPageQuery = {
  response: AccountManagementPageQuery$data;
  variables: AccountManagementPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "about",
  "storageKey": null
},
v5 = [
  (v0/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "service",
    "storageKey": null
  },
  (v0/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ProfileNodeConnection",
  "kind": "LinkedField",
  "name": "profiles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "platform",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soundLink",
  "storageKey": null
},
v15 = [
  (v0/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "releaseDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVisible",
        "storageKey": null
      },
      (v13/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tracksCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canDelete",
        "storageKey": null
      },
      (v14/*: any*/)
    ],
    "type": "ReleaseInterface",
    "abstractKey": "__isReleaseInterface"
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "isAccepted",
    "value": true
  }
],
v17 = [
  (v2/*: any*/),
  (v0/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastActiveAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v1/*: any*/),
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNode",
          "kind": "LinkedField",
          "name": "spotifyProfile",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ArtistNode",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v19/*: any*/),
    (v0/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v2/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PartnerNode",
  "abstractKey": null
},
v22 = [
  (v13/*: any*/),
  (v12/*: any*/),
  (v0/*: any*/)
],
v23 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "OfferNodeConnection",
  "kind": "LinkedField",
  "name": "offers",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OfferNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyNode",
              "kind": "LinkedField",
              "name": "company",
              "plural": false,
              "selections": (v17/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PartnerNode",
              "kind": "LinkedField",
              "name": "partner",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v11/*: any*/),
                    (v6/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/)
                  ],
                  "type": "ActorInterface",
                  "abstractKey": "__isActorInterface"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ArtistNode",
              "kind": "LinkedField",
              "name": "artist",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v11/*: any*/),
                    (v6/*: any*/),
                    (v2/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/)
                  ],
                  "type": "ActorInterface",
                  "abstractKey": "__isActorInterface"
                }
              ],
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ReleaseNodeConnection",
                  "kind": "LinkedField",
                  "name": "releases",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ReleaseNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ReleaseNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v22/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnreleasedReleaseNodeConnection",
                  "kind": "LinkedField",
                  "name": "unreleasedReleases",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UnreleasedReleaseNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "UnreleasedReleaseNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v22/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "OfferFeaturedDealInterface",
              "abstractKey": "__isOfferFeaturedDealInterface"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "offers(isAccepted:true)"
},
v24 = [
  (v0/*: any*/),
  (v11/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v26 = [
  (v1/*: any*/),
  (v13/*: any*/),
  (v12/*: any*/)
],
v27 = [
  (v0/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v19/*: any*/),
          (v0/*: any*/),
          (v25/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateJoined",
        "storageKey": null
      },
      (v21/*: any*/)
    ],
    "type": "ActorInterface",
    "abstractKey": "__isActorInterface"
  }
],
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recipientEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "ReferralInterface",
  "abstractKey": "__isReferralInterface"
},
v29 = [
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  (v0/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountManagementPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ArtistManageBank_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EmailSubscriptions_user"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ManageSubscription_user"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BasicInfoFormArtist_artist"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArtistEditSocialLinks_artist"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArtistManagerInfo_artist"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArtistManageReleases_artist"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArtistManageDeals_artist"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArtistViewTeam_teamMembers"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FeaturedDealNodeConnection",
                "kind": "LinkedField",
                "name": "featuredDeals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeaturedDealNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeaturedDealNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ArtistManageDeals_featuredDeals"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PartnerNode",
            "kind": "LinkedField",
            "name": "partner",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BasicInfoFormPartner_partner"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PartnerReferrals_partner"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArtistReferrals_partner"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNode",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CompanyInfo_company"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CompanySocialLinks_company"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CompanyTeam_company"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PartnerViewRoster_artistRoster"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountManagementPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeConnectedAccountApiId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeLoginLink",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEmailSubscriptionNodeConnection",
            "kind": "LinkedField",
            "name": "emailSubscriptions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserEmailSubscriptionNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserEmailSubscriptionNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isSubscribed",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableProductName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripePriceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PriceOption",
            "kind": "LinkedField",
            "name": "availableSubscriptionPrices",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "period",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GenreNode",
                "kind": "LinkedField",
                "name": "genre",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visible",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partnershipStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistSeekingServiceNodeConnection",
                "kind": "LinkedField",
                "name": "seekingServices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArtistSeekingServiceNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArtistSeekingServiceNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "managerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "managerLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "managerCompany",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "managerEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v10/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": "-releaseDate"
                  }
                ],
                "concreteType": "ReleaseNodeConnection",
                "kind": "LinkedField",
                "name": "releasesPrefetch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReleaseNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "releasesPrefetch(first:1000,orderBy:\"-releaseDate\")"
              },
              {
                "alias": null,
                "args": [
                  (v10/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": "-createdAt"
                  }
                ],
                "concreteType": "UnreleasedReleaseNodeConnection",
                "kind": "LinkedField",
                "name": "unreleasedReleasesPrefetch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnreleasedReleaseNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnreleasedReleaseNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "unreleasedReleasesPrefetch(first:1000,orderBy:\"-createdAt\")"
              },
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FeaturedDealNodeConnection",
                "kind": "LinkedField",
                "name": "featuredDeals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeaturedDealNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeaturedDealNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inPocketAmountRaising",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "marketingAmountRaising",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "creativeAmountRaising",
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TikTokSoundNodeConnection",
                            "kind": "LinkedField",
                            "name": "tiktokSounds",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TikTokSoundNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TikTokSoundNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whyInvestNow",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partnerSplitPreRecoupment",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partnerSplitPostRecoupment",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "termLengthMonths",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SoundRecordingNodeConnection",
                            "kind": "LinkedField",
                            "name": "soundRecordings",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SoundRecordingNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SoundRecordingNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReleaseNodeConnection",
                            "kind": "LinkedField",
                            "name": "releases",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleaseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReleaseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v24/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnreleasedReleaseNodeConnection",
                            "kind": "LinkedField",
                            "name": "unreleasedReleases",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UnreleasedReleaseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnreleasedReleaseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v24/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalAmountRaising",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleaseNodeConnection",
                                "kind": "LinkedField",
                                "name": "releases",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReleaseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReleaseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v26/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UnreleasedReleaseNodeConnection",
                                "kind": "LinkedField",
                                "name": "unreleasedReleases",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnreleasedReleaseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UnreleasedReleaseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v26/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "OfferFeaturedDealInterface",
                            "abstractKey": "__isOfferFeaturedDealInterface"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PartnerNode",
            "kind": "LinkedField",
            "name": "partner",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partnerReferralsMaxAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PartnerToPartnerReferralNodeConnection",
                "kind": "LinkedField",
                "name": "partnerReferrals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnerToPartnerReferralNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerToPartnerReferralNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerNode",
                            "kind": "LinkedField",
                            "name": "recipientPartner",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PartnerToArtistReferralNodeConnection",
                "kind": "LinkedField",
                "name": "artistReferrals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnerToArtistReferralNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerToArtistReferralNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArtistNode",
                            "kind": "LinkedField",
                            "name": "recipientArtist",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNode",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyServiceNodeConnection",
                    "kind": "LinkedField",
                    "name": "services",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyServiceNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyServiceNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GenreNodeConnection",
                    "kind": "LinkedField",
                    "name": "genres",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GenreNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GenreNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OfferNode",
                    "kind": "LinkedField",
                    "name": "caseStudyOffer",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "OfferNodeConnection",
                    "kind": "LinkedField",
                    "name": "offers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OfferNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OfferNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArtistNode",
                                "kind": "LinkedField",
                                "name": "artist",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleaseNodeConnection",
                                "kind": "LinkedField",
                                "name": "releases",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReleaseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReleaseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v29/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UnreleasedReleaseNodeConnection",
                                "kind": "LinkedField",
                                "name": "unreleasedReleases",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnreleasedReleaseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UnreleasedReleaseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v29/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "offers(isAccepted:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnerNode",
                    "kind": "LinkedField",
                    "name": "recipientPartner",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "activePartners",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "isActive",
                        "value": true
                      }
                    ],
                    "concreteType": "PartnerNodeConnection",
                    "kind": "LinkedField",
                    "name": "partners",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "partners(isActive:true)"
                  },
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v1/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "websiteUrl",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnerNodeConnection",
                    "kind": "LinkedField",
                    "name": "partners",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PartnerToCompanyPartnerReferralNodeConnection",
                    "kind": "LinkedField",
                    "name": "partnerCompanyReferrals",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerToCompanyPartnerReferralNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerToCompanyPartnerReferralNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v23/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "febcaf5363a5559de70c38bd5904fef3",
    "id": null,
    "metadata": {},
    "name": "AccountManagementPageQuery",
    "operationKind": "query",
    "text": "query AccountManagementPageQuery {\n  settings {\n    ...ArtistManageBank_user\n    ...EmailSubscriptions_user\n    ...ManageSubscription_user\n    artist {\n      ...BasicInfoFormArtist_artist\n      ...ArtistEditSocialLinks_artist\n      ...ArtistManagerInfo_artist\n      ...ArtistManageReleases_artist\n      ...ArtistManageDeals_artist\n      ...ArtistViewTeam_teamMembers\n      featuredDeals {\n        edges {\n          node {\n            ...ArtistManageDeals_featuredDeals\n            id\n          }\n        }\n      }\n      id\n    }\n    partner {\n      ...BasicInfoFormPartner_partner\n      ...PartnerReferrals_partner\n      ...ArtistReferrals_partner\n      company {\n        ...CompanyInfo_company\n        ...CompanySocialLinks_company\n        ...CompanyTeam_company\n        id\n      }\n      ...PartnerViewRoster_artistRoster\n      id\n    }\n    id\n  }\n}\n\nfragment ArtistEditSocialLinks_artist on ArtistNode {\n  id\n  profiles {\n    edges {\n      node {\n        id\n        url\n        platform\n      }\n    }\n  }\n}\n\nfragment ArtistManageBank_user on UserNode {\n  id\n  stripeConnectedAccountApiId\n  stripeLoginLink\n}\n\nfragment ArtistManageDeals_artist on ArtistNode {\n  managerName\n  managerLink\n  managerCompany\n  managerEmail\n  ...DealMerchandisingFormPage_artist\n}\n\nfragment ArtistManageDeals_featuredDeals on FeaturedDealNode {\n  id\n  inPocketAmountRaising\n  marketingAmountRaising\n  creativeAmountRaising\n  soundLink\n  tiktokSounds {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  whyInvestNow\n  partnerSplitPreRecoupment\n  partnerSplitPostRecoupment\n  termLengthMonths\n  soundRecordings {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  releases {\n    edges {\n      node {\n        id\n        __typename\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        id\n        __typename\n      }\n    }\n  }\n  ...DealManageable_featuredDeal\n}\n\nfragment ArtistManageReleases_artist on ArtistNode {\n  id\n  releasesPrefetch(orderBy: \"-releaseDate\", first: 1000) {\n    edges {\n      node {\n        ...ArtistManageReleases_releasesSection\n        id\n      }\n    }\n  }\n  unreleasedReleasesPrefetch(orderBy: \"-createdAt\", first: 1000) {\n    edges {\n      node {\n        ...ArtistManageReleases_releasesSection\n        id\n      }\n    }\n  }\n}\n\nfragment ArtistManageReleases_releasesSection on ReleaseInterface {\n  __isReleaseInterface: __typename\n  __typename\n  id\n  releaseType\n  releaseDate\n  updatedAt\n  ...ReleaseListItem_release\n}\n\nfragment ArtistManagerInfo_artist on ArtistNode {\n  id\n  managerName\n  managerLink\n  managerCompany\n  managerEmail\n}\n\nfragment ArtistReferrals_partner on PartnerNode {\n  id\n  artistReferrals {\n    edges {\n      node {\n        id\n        ...ReferralRecipientInvited_referral\n        recipientArtist {\n          ...ReferralRecipientActive_recipient\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ArtistViewTeam_teamMembers on ArtistNode {\n  offers(isAccepted: true) {\n    edges {\n      node {\n        ...TeamList_offers\n        id\n      }\n    }\n  }\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment AvatarName_actor on ActorInterface {\n  __isActorInterface: __typename\n  __typename\n  slug\n  displayName\n  ...AvatarIcon_actor\n  ... on PartnerNode {\n    company {\n      slug\n      displayName\n      id\n    }\n  }\n}\n\nfragment BasicInfoFormArtist_artist on ArtistNode {\n  id\n  thumbnailUrl\n  displayName\n  location\n  about\n  genre {\n    id\n  }\n  visible\n  slug\n  user {\n    phoneNumber\n    id\n  }\n  partnershipStatus\n  seekingServices {\n    edges {\n      node {\n        service\n        id\n      }\n    }\n  }\n}\n\nfragment BasicInfoFormPartner_partner on PartnerNode {\n  id\n  thumbnailUrl\n  displayName\n  location\n  about\n  slug\n  user {\n    phoneNumber\n    id\n  }\n}\n\nfragment CaseStudyOffer_company on CompanyNode {\n  offers(isAccepted: true) {\n    edges {\n      node {\n        id\n        ...useOfferName\n      }\n    }\n  }\n}\n\nfragment CompanyInfo_company on CompanyNode {\n  id\n  services {\n    edges {\n      node {\n        service\n        id\n      }\n    }\n  }\n  genres {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  caseStudyOffer {\n    id\n  }\n  ...CaseStudyOffer_company\n  recipientPartner {\n    id\n  }\n  ...RecipientPartner_company\n  displayName\n  slug\n  thumbnailUrl\n  location\n  websiteUrl\n  about\n}\n\nfragment CompanySocialLinks_company on CompanyNode {\n  id\n  profiles {\n    edges {\n      node {\n        id\n        url\n        platform\n      }\n    }\n  }\n}\n\nfragment CompanyTeam_company on CompanyNode {\n  displayName\n  ...UserListCompanyTeam_company\n}\n\nfragment DealManageMenu_featuredDeal on FeaturedDealNode {\n  id\n  status\n}\n\nfragment DealManageable_featuredDeal on FeaturedDealNode {\n  id\n  status\n  totalAmountRaising\n  ...ReleaseIconsNames_query\n  ...DealManageMenu_featuredDeal\n}\n\nfragment DealMerchandisingFormPage_artist on ArtistNode {\n  id\n}\n\nfragment EmailSubscriptions_user on UserNode {\n  userType\n  emailSubscriptions {\n    edges {\n      node {\n        emailType\n        isSubscribed\n        id\n      }\n    }\n  }\n}\n\nfragment ManageSubscription_user on UserNode {\n  id\n  availableProductName\n  stripePriceId\n  availableSubscriptionPrices {\n    id\n    price\n    period\n  }\n}\n\nfragment PartnerReferrals_partner on PartnerNode {\n  id\n  partnerReferralsMaxAllowed\n  partnerReferrals {\n    edges {\n      node {\n        id\n        ...ReferralRecipientInvited_referral\n        recipientPartner {\n          ...ReferralRecipientActive_recipient\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment PartnerViewRoster_artistRoster on PartnerNode {\n  offers(isAccepted: true) {\n    edges {\n      node {\n        ...TeamList_offers\n        id\n      }\n    }\n  }\n}\n\nfragment RecipientPartner_company on CompanyNode {\n  activePartners: partners(isActive: true) {\n    edges {\n      node {\n        id\n        displayName\n      }\n    }\n  }\n}\n\nfragment ReferralRecipientActive_recipient on ActorInterface {\n  __isActorInterface: __typename\n  ...AvatarName_actor\n  dateJoined\n  user {\n    status\n    id\n  }\n}\n\nfragment ReferralRecipientInvited_referral on ReferralInterface {\n  __isReferralInterface: __typename\n  __typename\n  id\n  recipientEmail\n  createdAt\n}\n\nfragment ReleaseDetails_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  isVisible\n  name\n  ...useReleaseMetadata_release\n}\n\nfragment ReleaseIconsNames_query on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  ...ReleaseIconsNames_releaseImages\n  ...useFeaturedDealTitle\n}\n\nfragment ReleaseIconsNames_releaseImages on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n}\n\nfragment ReleaseListItem_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  thumbnailUrl\n  isVisible\n  ...ReleaseDetails_release\n  ...ReleaseStatusMenu_release\n}\n\nfragment ReleaseStatusMenu_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  __typename\n  id\n  isVisible\n  canDelete\n  ...UpdateOrCreateReleaseModal_release\n}\n\nfragment TeamList_offers on OfferNode {\n  id\n  company {\n    displayName\n    id\n  }\n  partner {\n    id\n    displayName\n    ...AvatarName_actor\n  }\n  artist {\n    id\n    ...AvatarName_actor\n  }\n  ...useFeaturedDealTitle\n}\n\nfragment UpdateOrCreateReleaseModal_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  __typename\n  id\n  name\n  releaseType\n  soundLink\n  isVisible\n  tracksCount\n}\n\nfragment UserListCompanyTeam_company on CompanyNode {\n  partners {\n    edges {\n      node {\n        id\n        ...ReferralRecipientActive_recipient\n      }\n    }\n  }\n  partnerCompanyReferrals {\n    edges {\n      node {\n        id\n        ...ReferralRecipientInvited_referral\n      }\n    }\n  }\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useFeaturedDealTitle on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n}\n\nfragment useOfferName on OfferNode {\n  artist {\n    displayName\n    id\n  }\n  releases {\n    edges {\n      node {\n        name\n        type\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        name\n        type\n        id\n      }\n    }\n  }\n}\n\nfragment useReleaseMetadata_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  releaseType\n  tracksCount\n  releaseDate\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a921ad20a704b47022e0abd9bf8635d5";

export default node;
